import * as React from 'react';
import { render } from 'react-dom';
import * as uuid from 'uuid';
import Snackbar from '../components/Snackbar';
import {
  INotificationManager,
  INotificationManagerOptions,
  INotificationOptions,
} from '../types';

export default class NotificationManager implements INotificationManager {
  public readonly notificationContainerId: string;

  constructor(options: INotificationManagerOptions) {
    const { notificationContainerId } = options;
    this.notificationContainerId = notificationContainerId;
  }

  success({ message, autoHideDuration }: INotificationOptions) {
    return this.createNotification({
      message,
      autoHideDuration,
      variant: 'success',
    });
  }

  warning({ message, autoHideDuration }: INotificationOptions) {
    return this.createNotification({
      message,
      autoHideDuration,
      variant: 'warning',
    });
  }

  info({ message, autoHideDuration }: INotificationOptions) {
    return this.createNotification({
      message,
      autoHideDuration,
      variant: 'info',
    });
  }

  error({ message, autoHideDuration }: INotificationOptions) {
    return this.createNotification({
      message,
      autoHideDuration,
      variant: 'error',
    });
  }

  createNotification(options: INotificationOptions) {
    const { message, variant = 'info', autoHideDuration } = options;

    if (!document.getElementById(this.notificationContainerId)) {
      throw new Error(
        `Error creating NotificationManager. Invalid notification container element id "${this.notificationContainerId}"`
      );
    }

    return render(
      <Snackbar
        key={`notification-${uuid.v4()}`}
        open={true}
        message={message}
        variant={variant}
        autoHideDuration={autoHideDuration}
      />,
      document.getElementById(this.notificationContainerId)
    );
  }
}
